import type { Action } from 'react-sweet-state';
import { createStateHook, createActionsHook, createStore } from 'react-sweet-state';

type ExperimentInfoState = {
	shouldShowModal?: boolean;
	cohort?: string;
	epMessageReady?: boolean;
	featureGateEnabled?: boolean;
	startModalFeatureDiscovery?: boolean;
	stopEpMessage?: (force?: boolean) => Promise<void>;
	stopModalFeatureDiscovery?: () => void;
};

const initialState: ExperimentInfoState = {};

const actions = {
	setCohort:
		(cohort: string): Action<ExperimentInfoState> =>
		({ setState }) => {
			setState({ cohort });
		},
	setEpMessageReady:
		(epMessageReady: boolean): Action<ExperimentInfoState> =>
		({ setState }) => {
			setState({ epMessageReady });
		},
	setShouldShowModal:
		(shouldShowModal: boolean): Action<ExperimentInfoState> =>
		({ setState }) => {
			setState({ shouldShowModal });
		},
	setStartModalFeatureDiscovery:
		(startModalFeatureDiscovery: boolean): Action<ExperimentInfoState> =>
		({ setState }) => {
			setState({ startModalFeatureDiscovery });
		},
	setStopEpMessage:
		(stopEpMessage: (force?: boolean) => Promise<void>): Action<ExperimentInfoState> =>
		({ setState }) => {
			setState({ stopEpMessage });
		},
	setStopModalFeatureDiscovery:
		(stopModalFeatureDiscovery: () => void): Action<ExperimentInfoState> =>
		({ setState }) => {
			setState({ stopModalFeatureDiscovery });
		},
};

const Store = createStore<ExperimentInfoState, typeof actions>({
	initialState,
	actions,
});

export const useExperimentInfoActions = createActionsHook(Store);
export const useExperimentInfo = createStateHook(Store);
